module.exports = __webpack_public_path__ + "img/pimcore_partner_gold_mds.eu.8bd96f20.svg";